import Box from "@/components/Box";
import { CMP_PERMISSION_MULTIPATIENT_ORDERS } from "@/components/organisations/constants";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { isMultiplePatientOrdersEnabled } from "@/core/config";
import { MODAL_Z_INDEX } from "@/core/constants";
import Group from "@/tpo/Group";
import ToggleSwitch from "@/tpo/ToggleSwitch";
import Tooltip from "@/tpo/Tooltip";
import { QuestionButton } from "@/v2/Buttons";

/** True if any test line (including Cyrex add-ons) uses a Cyrex-fulfilled product. */
function basketHasCyrexProduct(basket) {
  return Boolean(
    basket?.productLineItems?.some(
      item =>
        item.product?.isCyrex || item.addons?.some(addon => addon.product?.isCyrex)
    )
  );
}

export default function MultiplePatientsToggle({ basket, onTogglingMultiplePatientsOption }) {
  const { permissions = [] } = useOrganisationContext();

  if (!isMultiplePatientOrdersEnabled()) {
    return null;
  }

  if (!permissions.includes(CMP_PERMISSION_MULTIPATIENT_ORDERS)) {
    return null;
  }

  if (basketHasCyrexProduct(basket) && !basket?.multiplePatientsEnabled) {
    return null;
  }

  return (
    <Group gap={20} position="relative">
      <Group alignItems="center" gap={10}>
        <Tooltip
          content={
            <Box
              bg="black"
              color="white"
              maxWidth={200}
              p={2}
              pb={20}
              borderRadius={5}
              zIndex={MODAL_Z_INDEX + 1}
              position="relative"
            >
              Select if you want to order for multiple patients in the same household.
            </Box>
          }
          placement="bottom-end"
        >
          <QuestionButton bg="dark" color="white" />
        </Tooltip>
        <Box color="dark" fontFamily="gilroyBold" fontSize={15} lineHeight="24px">
          Multi patient order?
        </Box>
      </Group>
      <ToggleSwitch
        onChange={multiplePatients => onTogglingMultiplePatientsOption(multiplePatients)}
        value={basket?.multiplePatientsEnabled}
        data-testid="multiple-patients-toggle"
        id="multiple-patients-toggle"
        offBg="haze"
      />
    </Group>
  );
}
